export default "__VITE_ASSET__52h40Udi__"